import React from 'react';
import styled from 'styled-components/macro';
import ArrowInicio from '../../svg/ArrowInicio';

const RoundButtonArrow = ({ variant = 'down', background = '#215ccc', color = 'white', onClick = () => { } }) => {
  let rotation = 0;

  if (variant === 'up') {
    rotation = 180;
  } else if (variant === 'left') {
    rotation = 90;
  } else if (variant === 'right') {
    rotation = -90;
  }

  return (
    <RoundButtonContainer rotation={rotation} onClick={onClick} background={background} color={color}>
      <ArrowInicio />
    </RoundButtonContainer>
  );
};

const RoundButtonContainer = styled.button`
  width: 25px;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  transition-duration: 250ms;
  background: ${({ background }) => background};
  color:${({ color }) => color};
  transform: ${({ rotation }) => `rotate(${rotation}deg)`};
`;

export default RoundButtonArrow;
